import config from './config'
import { authHeader, authHeaderUpload } from '../_helpers'
import { router } from '@/_helpers/index'
import { localStore } from '@/_utils/localstore'
import _ from 'lodash'

export function commonService(endpoint: any) {
  return {
    getAll,
    addOne,
    getOne,
    updateOne,
    updateStatic,
    deleteOne,
    uploadFile,
    hasRefs,
    canEdit,
    canDelete,
    postData,
  }
  async function getAll(params: any = {}): Promise<any> {
    const requestOptions = {
      method: 'GET',
      headers: authHeader()
    }
    const url = new URL(`${config.apiUrl}/${endpoint}`)
    // Add params to url
    Object.keys(params).forEach(key => url.searchParams.append(key, params[key]))

    return fetch(url.href, (requestOptions as any)).then(
      handleResponse
    ).catch(response => Promise.reject(response))
  }

  async function addOne(data: any): Promise<any> {
    const requestOptions = {
      method: 'POST',
      headers: authHeader(),
      body: JSON.stringify(data)
    }

    return fetch(`${config.apiUrl}/${endpoint}`, requestOptions as any).then(
      handleResponse
    ).catch(response => Promise.reject(response))
  }

  async function updateOne(data: any): Promise<any> {
    const requestOptions = {
      method: 'PATCH',
      headers: authHeader(),
      body: JSON.stringify(data)
    }

    return fetch(`${config.apiUrl}/${endpoint}/${data._id}`, requestOptions as any).then(
      handleResponse
    ).catch(response => Promise.reject(response))
  }

  async function updateStatic(data: any): Promise<any> {
    const requestOptions = {
      method: 'PATCH',
      headers: authHeader(),
      body: JSON.stringify(data)
    }

    return fetch(`${config.apiUrl}/${endpoint}`, requestOptions as any).then(
      handleResponse
    ).catch(response => Promise.reject(response))
  }

  async function getOne(id: string): Promise<any> {
    const requestOptions = {
      method: 'GET',
      headers: authHeader(),
    }

    return fetch(`${config.apiUrl}/${endpoint}/${id}`, requestOptions as any).then(
      handleResponse
    ).catch(response => Promise.reject(response))
  }
  async function deleteOne(id: string): Promise<any> {
    const requestOptions = {
      method: 'DELETE',
      headers: authHeader(),
    }

    return fetch(`${config.apiUrl}/${endpoint}/${id}`, requestOptions as any).then(
      handleResponse
    ).catch(response => Promise.reject(response))
  }
  async function postData(payload: any): Promise<any> {
    const requestOptions = {
      method: 'POST',
      headers: authHeader(),
      body: JSON.stringify(payload)
    }

    return fetch(`${config.apiUrl}/${endpoint}`, requestOptions as any).then(
      handleResponse
    ).catch(response => Promise.reject(response))
  }
  async function uploadFile(file: File): Promise<any> {
    // Create new form data to upload
    const data = new FormData()
    data.append('file', file)
    const requestOptions = {
      method: 'POST',
      headers: authHeaderUpload(),
      body: data,
    }

    return fetch(`${config.apiUrl}/api/v1/upload`, requestOptions as any).then(
      handleResponse
    ).catch(response => Promise.reject(response))
  }
  async function hasRefs(id: string): Promise<any> {
    const requestOptions = {
      method: 'GET',
      headers: authHeader(),
    }

    return fetch(`${config.apiUrl}/${endpoint}/${id}/has-refs`, requestOptions as any).then(
      handleResponse
    ).catch(response => Promise.reject(response))
  }
  function canEdit() {
    const user = JSON.parse(localStore.getItem('user') as string)
    if (!user || _.isNil(user.access_right)) {
      router.push('/login')
    }

    return user.access_right === 1 || user.access_right === 2
  }
  function canDelete() {
    const user = JSON.parse(localStore.getItem('user') as string)
    if (!user || _.isNil(user.access_right)) {
      router.push('/login')
    }

    return user.access_right === 1 || user.access_right === 2
  }
  function handleResponse(response: any): any {
    return response.text().then((text: string) => {
      const responseJson = text && JSON.parse(text)
      if (!response.ok) {
        // Token expire or not logged in, goto login page
        if (response.status === 401) {
          router.push('/login')
        }

        const errorMsg = (responseJson && responseJson.message) || response.statusText
        return Promise.reject(errorMsg)
      }

      return Promise.resolve(responseJson)
    })
  }
}